// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ContactAudit from "./contact-audit.js"
import ContactEmail from "./contact-email.js"
import ContactPhoneNumber from "./contact-phone-number.js"
import ContactRelationship from "./contact-relationship.js"
import ContactType from "./contact-type.js"
import Country from "./country.js"
import CountryState from "./country-state.js"
import School from "./school.js"
import SchoolClass from "./school-class.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "account_manager_id": {
      "column": {
        "default": null,
        "name": "account_manager_id",
        "null": true,
        "type": null
      },
      "name": "account_manager_id",
      "selected_by_default": null,
      "translated": false
    },
    "contact_points_count": {
      "column": {
        "default": "0",
        "name": "contact_points_count",
        "null": false,
        "type": "integer"
      },
      "name": "contact_points_count",
      "selected_by_default": null,
      "translated": false
    },
    "contact_type_id": {
      "column": {
        "default": null,
        "name": "contact_type_id",
        "null": true,
        "type": null
      },
      "name": "contact_type_id",
      "selected_by_default": null,
      "translated": false
    },
    "country_id": {
      "column": {
        "default": null,
        "name": "country_id",
        "null": true,
        "type": null
      },
      "name": "country_id",
      "selected_by_default": null,
      "translated": false
    },
    "country_state_id": {
      "column": {
        "default": null,
        "name": "country_state_id",
        "null": true,
        "type": null
      },
      "name": "country_state_id",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "email": {
      "column": null,
      "name": "email",
      "selected_by_default": null,
      "translated": false
    },
    "first_name": {
      "column": {
        "default": null,
        "name": "first_name",
        "null": true,
        "type": "string"
      },
      "name": "first_name",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "last_name": {
      "column": {
        "default": null,
        "name": "last_name",
        "null": true,
        "type": "string"
      },
      "name": "last_name",
      "selected_by_default": null,
      "translated": false
    },
    "phone_number": {
      "column": null,
      "name": "phone_number",
      "selected_by_default": null,
      "translated": false
    },
    "points": {
      "column": {
        "default": "0",
        "name": "points",
        "null": false,
        "type": "integer"
      },
      "name": "points",
      "selected_by_default": null,
      "translated": false
    },
    "points_last_seven_days": {
      "column": {
        "default": "0",
        "name": "points_last_seven_days",
        "null": false,
        "type": "integer"
      },
      "name": "points_last_seven_days",
      "selected_by_default": null,
      "translated": false
    },
    "points_last_thirty_days": {
      "column": {
        "default": "0",
        "name": "points_last_thirty_days",
        "null": false,
        "type": "integer"
      },
      "name": "points_last_thirty_days",
      "selected_by_default": null,
      "translated": false
    },
    "points_last_ninety_days": {
      "column": {
        "default": "0",
        "name": "points_last_ninety_days",
        "null": false,
        "type": "integer"
      },
      "name": "points_last_ninety_days",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "Contact",
  "collectionKey": "contacts",
  "collectionName": "contacts",
  "i18nKey": "contact",
  "camelizedLower": "contact",
  "name": "Contact",
  "nameDasherized": "contact",
  "pluralName": "contacts",
  "ransackable_associations": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "account_manager_id",
      "name": "account_manager",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "Contact::Audit",
      "collectionName": "contact_audits",
      "foreignKey": "contact_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ContactAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "children_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "children_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactEmail",
      "collectionName": "contact_emails",
      "foreignKey": "contact_id",
      "name": "contact_emails",
      "macro": "has_many",
      "resource_name": "ContactEmail",
      "through": null
    },
    {
      "className": "ContactInfo",
      "collectionName": null,
      "foreignKey": "contact_id",
      "name": "contact_infos",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ContactPhoneNumber",
      "collectionName": "contact_phone_numbers",
      "foreignKey": "contact_id",
      "name": "contact_phone_numbers",
      "macro": "has_many",
      "resource_name": "ContactPhoneNumber",
      "through": null
    },
    {
      "className": "ContactPoint",
      "collectionName": "contact_points",
      "foreignKey": "contact_id",
      "name": "contact_points",
      "macro": "has_many",
      "resource_name": "ContactPoint",
      "through": null
    },
    {
      "className": "ContactType",
      "collectionName": "contact_types",
      "foreignKey": "contact_type_id",
      "name": "contact_type",
      "macro": "belongs_to",
      "resource_name": "ContactType",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "country",
      "macro": "belongs_to",
      "resource_name": "Country",
      "through": null
    },
    {
      "className": "CountryState",
      "collectionName": "country_states",
      "foreignKey": "country_state_id",
      "name": "country_state",
      "macro": "belongs_to",
      "resource_name": "CountryState",
      "through": null
    },
    {
      "className": "Contact::Audit",
      "collectionName": "contact_audits",
      "foreignKey": "contact_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContactAudit",
      "through": null
    },
    {
      "className": "Contact::Translation",
      "collectionName": null,
      "foreignKey": "contact_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Dialogue",
      "collectionName": "dialogues",
      "foreignKey": "contact_id",
      "name": "dialogues",
      "macro": "has_many",
      "resource_name": "Dialogue",
      "through": null
    },
    {
      "className": "Dialogue",
      "collectionName": "dialogues",
      "foreignKey": "contact_id",
      "name": "latest_dialogue",
      "macro": "has_one",
      "resource_name": "Dialogue",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "parent_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parents",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "parent_relationships"
    },
    {
      "className": "ContactEmail",
      "collectionName": "contact_emails",
      "foreignKey": "contact_id",
      "name": "primary_email",
      "macro": "has_one",
      "resource_name": "ContactEmail",
      "through": null
    },
    {
      "className": "ContactPhoneNumber",
      "collectionName": "contact_phone_numbers",
      "foreignKey": "contact_id",
      "name": "primary_phone_number",
      "macro": "has_one",
      "resource_name": "ContactPhoneNumber",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "school_group_school_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "school_group_schools_contact_relationships"
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school_group_schools",
      "macro": "has_many",
      "resource_name": "School",
      "through": "school_group_school_contacts"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "school_group_schools_contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "teacher_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "teachers",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "teacher_relationships"
    },
    {
      "className": "Contact::Translation",
      "collectionName": null,
      "foreignKey": "contact_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_manager_id",
      "column": {
        "default": null,
        "name": "account_manager_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "contact_points_count",
      "column": {
        "default": "0",
        "name": "contact_points_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "contact_type_id",
      "column": {
        "default": null,
        "name": "contact_type_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "country_id",
      "column": {
        "default": null,
        "name": "country_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "country_state_id",
      "column": {
        "default": null,
        "name": "country_state_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "first_name",
      "column": {
        "default": null,
        "name": "first_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "import_identifier",
      "column": {
        "default": null,
        "name": "import_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "last_name",
      "column": {
        "default": null,
        "name": "last_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "points",
      "column": {
        "default": "0",
        "name": "points",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "points_last_ninety_days",
      "column": {
        "default": "0",
        "name": "points_last_ninety_days",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "points_last_seven_days",
      "column": {
        "default": "0",
        "name": "points_last_seven_days",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "points_last_thirty_days",
      "column": {
        "default": "0",
        "name": "points_last_thirty_days",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "with_any_pro_subscription"
    },
    {
      "name": "with_any_subscription"
    },
    {
      "name": "without_any_pro_subscription"
    },
    {
      "name": "without_any_subscription"
    }
  ],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "account_manager_id",
      "name": "account_manager",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "children_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "children_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactType",
      "collectionName": "contact_types",
      "foreignKey": "contact_type_id",
      "name": "contact_type",
      "macro": "belongs_to",
      "resource_name": "ContactType",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "country",
      "macro": "belongs_to",
      "resource_name": "Country",
      "through": null
    },
    {
      "className": "CountryState",
      "collectionName": "country_states",
      "foreignKey": "country_state_id",
      "name": "country_state",
      "macro": "belongs_to",
      "resource_name": "CountryState",
      "through": null
    },
    {
      "className": "Contact::Audit",
      "collectionName": "contact_audits",
      "foreignKey": "contact_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContactAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parents",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "parent_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "parent_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactEmail",
      "collectionName": "contact_emails",
      "foreignKey": "contact_id",
      "name": "primary_email",
      "macro": "has_one",
      "resource_name": "ContactEmail",
      "through": null
    },
    {
      "className": "ContactPhoneNumber",
      "collectionName": "contact_phone_numbers",
      "foreignKey": "contact_id",
      "name": "primary_phone_number",
      "macro": "has_one",
      "resource_name": "ContactPhoneNumber",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "contact",
  "primaryKey": "id"
}

/** Frontend model for Contact. */
export default class Contact extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any | null} */
  accountManagerId() {
    return this.readAttributeUnderscore("account_manager_id")
  }

  /** @returns {boolean} */
  hasAccountManagerId() {
    const value = this.accountManagerId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  contactPointsCount() {
    return this.readAttributeUnderscore("contact_points_count")
  }

  /** @returns {boolean} */
  hasContactPointsCount() {
    const value = this.contactPointsCount()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  contactTypeId() {
    return this.readAttributeUnderscore("contact_type_id")
  }

  /** @returns {boolean} */
  hasContactTypeId() {
    const value = this.contactTypeId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  countryId() {
    return this.readAttributeUnderscore("country_id")
  }

  /** @returns {boolean} */
  hasCountryId() {
    const value = this.countryId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  countryStateId() {
    return this.readAttributeUnderscore("country_state_id")
  }

  /** @returns {boolean} */
  hasCountryStateId() {
    const value = this.countryStateId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  firstName() {
    return this.readAttributeUnderscore("first_name")
  }

  /** @returns {boolean} */
  hasFirstName() {
    const value = this.firstName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  lastName() {
    return this.readAttributeUnderscore("last_name")
  }

  /** @returns {boolean} */
  hasLastName() {
    const value = this.lastName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {number} */
  points() {
    return this.readAttributeUnderscore("points")
  }

  /** @returns {boolean} */
  hasPoints() {
    const value = this.points()

    return this._isPresent(value)
  }

  /** @returns {number} */
  pointsLastSevenDays() {
    return this.readAttributeUnderscore("points_last_seven_days")
  }

  /** @returns {boolean} */
  hasPointsLastSevenDays() {
    const value = this.pointsLastSevenDays()

    return this._isPresent(value)
  }

  /** @returns {number} */
  pointsLastThirtyDays() {
    return this.readAttributeUnderscore("points_last_thirty_days")
  }

  /** @returns {boolean} */
  hasPointsLastThirtyDays() {
    const value = this.pointsLastThirtyDays()

    return this._isPresent(value)
  }

  /** @returns {number} */
  pointsLastNinetyDays() {
    return this.readAttributeUnderscore("points_last_ninety_days")
  }

  /** @returns {boolean} */
  hasPointsLastNinetyDays() {
    const value = this.pointsLastNinetyDays()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("./user.js").default | null} */
  accountManager() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "account_manager"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadAccountManager() {
    if (!("accountManagerId" in this)) throw new Error("Foreign key method wasn't defined: accountManagerId")

    const id = this.accountManagerId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "account_manager",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  children() {
    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadChildren() {
    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship.js").default>} */
  childrenRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "children_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  loadChildrenRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "children_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {import("./contact-type.js").default | null} */
  contactType() {
    return this._readBelongsToReflection({modelClass: ContactType, reflectionName: "contact_type"})
  }

  /** @returns {Promise<import("./contact-type.js").default | null>} */
  loadContactType() {
    if (!("contactTypeId" in this)) throw new Error("Foreign key method wasn't defined: contactTypeId")

    const id = this.contactTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact_type",
        model: this,
        modelClass: ContactType
      },
      {ransack}
    )
  }

  /** @returns {import("./country.js").default | null} */
  country() {
    return this._readBelongsToReflection({modelClass: Country, reflectionName: "country"})
  }

  /** @returns {Promise<import("./country.js").default | null>} */
  loadCountry() {
    if (!("countryId" in this)) throw new Error("Foreign key method wasn't defined: countryId")

    const id = this.countryId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "country",
        model: this,
        modelClass: Country
      },
      {ransack}
    )
  }

  /** @returns {import("./country-state.js").default | null} */
  countryState() {
    return this._readBelongsToReflection({modelClass: CountryState, reflectionName: "country_state"})
  }

  /** @returns {Promise<import("./country-state.js").default | null>} */
  loadCountryState() {
    if (!("countryStateId" in this)) throw new Error("Foreign key method wasn't defined: countryStateId")

    const id = this.countryStateId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "country_state",
        model: this,
        modelClass: CountryState
      },
      {ransack}
    )
  }

  /** @returns {import("./contact-audit.js").default | null} */
  createAudit() {
    return this._readHasOneReflection({modelClass: ContactAudit, reflectionName: "create_audit"})
  }

  /** @returns {Promise<import("./contact-audit.js").default | null>} */
  loadCreateAudit() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "create_audit",
        model: this,
        modelClass: ContactAudit
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  parents() {
    return new Collection(
      {
        reflectionName: "parents",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "parents"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadParents() {
    return this._loadHasManyReflection(
      {
        reflectionName: "parents",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "parents"
          }
        }
      }
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship.js").default>} */
  parentRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["child_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "parent_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  loadParentRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["child_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "parent_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {import("./contact-email.js").default | null} */
  primaryEmail() {
    return this._readHasOneReflection({modelClass: ContactEmail, reflectionName: "primary_email"})
  }

  /** @returns {Promise<import("./contact-email.js").default | null>} */
  loadPrimaryEmail() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_email",
        model: this,
        modelClass: ContactEmail
      },
      {ransack}
    )
  }

  /** @returns {import("./contact-phone-number.js").default | null} */
  primaryPhoneNumber() {
    return this._readHasOneReflection({modelClass: ContactPhoneNumber, reflectionName: "primary_phone_number"})
  }

  /** @returns {Promise<import("./contact-phone-number.js").default | null>} */
  loadPrimaryPhoneNumber() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_phone_number",
        model: this,
        modelClass: ContactPhoneNumber
      },
      {ransack}
    )
  }

  /** @returns {import("./school.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: School, reflectionName: "school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: School
      },
      {ransack}
    )
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readHasOneReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readHasOneReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }
}
